import { useCallback, useEffect, useRef } from 'react';
import { logger } from './logger';

const isTestEnv = process.env.NODE_ENV === 'test';

export function useObservable<DATA = unknown>(eventName: string, log = false) {
  const notify = useCallback(
    (data: DATA) => {
      if (log) {
        logger.info(`notify "${eventName}"`, data);
      }
      window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
      if (isTestEnv) {
        setTimeout(() => {}, 0);
      }
    },
    [eventName, log]
  );

  return { notify };
}

export function useObserver<DATA = unknown>(name: string, fn: (data: CustomEvent<DATA>) => void) {
  const cb = useRef<(data: CustomEvent<DATA>) => void>();

  useEffect(() => {
    cb.current = fn;
  });

  useEffect(() => {
    const callback = (d: CustomEvent<DATA>) => {
      cb.current?.(d);
    };
    window.addEventListener(name, callback as EventListener);
    return () => {
      window.removeEventListener(name, callback as EventListener);
    };
  }, [name]);
}
